import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import LinkButton from 'components/LinkButton';

import './styles.css';

const InboxItemAttachments = props => {
  const { attachments } = props;

  return (
    <div className="inbox-item__attachments">
      <div className="inbox-item__attachments-title">
        {pluralize('Attachment', attachments.length)}:
      </div>
      <div className="inbox-item__attachments-list">
        {attachments.map((attachment, index) => (
          <div key={index} className="inbox-item__attachment-item">
            <LinkButton
              btnStyles={{
                fontSize: '0.8571rem',
                fontWeight: 400,
              }}
              text={attachment.name}
              link={attachment.link}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

InboxItemAttachments.propTypes = {
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default InboxItemAttachments;
